import { Button, Modal } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { config } from '@config'

import { StyledStrongText, StyledUnderlinedText } from '../StyledComponents'

interface Props {
  latitude?: number
  longitude?: number
  street?: string | string[]
  number?: string | string[]
  province?: string | string[]
  city?: string | string[]
  open: boolean
  tag?: string
  close: () => void
}

export const MapsModal: React.FC<Props> = ({
  latitude,
  longitude,
  street,
  number,
  city,
  province,
  tag,
  open,
  close,
}) => (
  <Modal open={open} keyboard maskClosable closable onCancel={close} destroyOnClose footer={false}>
    <>
      <StyledStrongText>{`${tag || '-'}`}</StyledStrongText>
      <div>
        <StyledUnderlinedText>Dirección:</StyledUnderlinedText> {street || '-'} {number || '-'}
      </div>
      <div>
        <StyledUnderlinedText>Ciudad:</StyledUnderlinedText> {city || '-'}
      </div>
      <div>
        <StyledUnderlinedText>Provincia:</StyledUnderlinedText> {province || '-'}
      </div>
      <div style={{ marginBottom: '10px' }}>
        <StyledUnderlinedText>Lat/Lon:</StyledUnderlinedText> {latitude || '-'}, {longitude || '-'}
      </div>
      <Button>
        <Link
          to={`${config.googleMapsUrl}/${latitude},${longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ir a Google Maps
        </Link>
      </Button>
    </>
  </Modal>
)
